<template>
    <EditModelLayout
        :indexRoute="$route('admin::languages.index')"
        :updateRoute="$route('admin::languages.update', { language: language.id })"
        :modelNameSingular="__('admin::languages.language')"
        :modelNamePlural="__('admin::languages.languages')"
        :form="form"
        :name="form.name"
    >

        <FormGroup :label="__('admin::labels.language')" :error="errors.name">
            <Input name="name" type="text" :has-error="exists(errors.name)" v-model="form.name" :required="true" />
        </FormGroup>

        <FormGroup :label="__('admin::labels.locale')" :error="errors.locale">
            <Input name="locale" type="text" :has-error="exists(errors.locale)" v-model="form.locale" :required="true" />
        </FormGroup>

    </EditModelLayout>
</template>

<script>
    export default {
        props: {
            errors: Object,
            language: Object,
        },
        data() {
            return {
                form: this.$inertia.form({
                    name: this.language.name,
                    locale: this.language.locale,
                })
            }
        },
    }
</script>